export enum GameStatus {
  Title = 'game_status--title',
  Started = 'game_status--started',
  Paused = 'game_status--paused',
  Ready = 'game_status--ready',
  Finished = 'game_status--finished',
  Leaderboard = 'game_status--leaderboard',
  PlayerDetails = 'game_status--player_details',
}
